import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import './Calendar.css';
import React from 'react';
import Comment from './Comment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'react-datepicker/dist/react-datepicker.css';
import { Grid } from '@mui/material';
import { formatCalendarTimezone } from '../utils/calendarTimezone';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

class Calendar extends React.Component {
  constructor(props) {
    super(props);
    const initialDate = this.props.data.auto;
    const isValidInitialDate = (date) => {
      if (!date) return false;
      const d = new Date(date);
      return !isNaN(d.getTime());
    };
    this.state = {
      calendar_answer:
        initialDate && isValidInitialDate(initialDate)
          ? new Date(initialDate)
          : null,
      convertedDateTime: null,
    };
  }

  isValidDate = (date) => {
    if (!date) return false;
    const d = new Date(date);
    return !isNaN(d.getTime());
  };

  // Parse date string with multiple format support
  parseDateString = (dateStr) => {
    if (!dateStr) return null;

    // If it's already a number (timestamp), convert directly
    if (typeof dateStr === 'number') {
      return new Date(dateStr);
    }

    // Try standard Date parsing first
    let date = new Date(dateStr);
    if (!isNaN(date.getTime())) {
      return date;
    }

    // Try common date formats using dayjs
    const formats = [
      'DD-MMM-YYYY', // 15-Mar-2023
      'DD/MMM/YYYY', // 15/Mar/2023
      'DD MMM YYYY', // 15 Mar 2023
      'MMM DD, YYYY', // Mar 15, 2023
      'YYYY-MM-DD', // 2023-03-15
      'DD/MM/YYYY', // 15/03/2023
      'MM/DD/YYYY', // 03/15/2023
      'DD-MM-YYYY', // 15-03-2023
      'YYYY/MM/DD', // 2023/03/15
      'DD-MMM-YYYY HH:mm', // 15-Mar-2023 10:30
      'DD/MM/YYYY HH:mm', // 15/03/2023 10:30
      'YYYY-MM-DD HH:mm', // 2023-03-15 10:30
    ];

    for (const format of formats) {
      const parsed = dayjs(dateStr, format);
      if (parsed.isValid()) {
        return parsed.toDate();
      }
    }

    return null;
  };

  componentDidMount() {
    let answer_data = this.props.form.answer_data[this.props.data.key];

    if (answer_data && answer_data.answer) {
      let date = this.parseDateString(answer_data.answer[0]);
      if (date && !isNaN(date.getTime())) {
        this.setState({
          calendar_answer: date,
          convertedDateTime: this.convertDateTime(date),
        });
      }
    } else if (this.props.data.auto) {
      // We are given a pre-filled ans
      // Set the date into the state
      let date = new Date(this.props.data.auto);

      console.log(date);
      if (!isNaN(date.getTime())) {
        this.setState({
          calendar_answer: date,
          convertedDateTime: this.convertDateTime(date),
        });

        // Set the date into the form answer state
        this.props.getDataFromComponent(
          { calendar_answer: date.getTime() },
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data
        );
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.data.auto.toString() != this.props.data.auto.toString()) {
      if (
        this.props.data.auto &&
        !this.props.form.answer_data[this.props.data.key]
      ) {
        this.props.getDataFromComponent(
          { calendar_answer: this.props.data.auto },
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data,
          this.props.data.outputFormat,
          this.props.data.timezone
        );
      }
    }
  }

  convertDateTime = (date) =>
    formatCalendarTimezone(
      date,
      this.props.data.timezone,
      this.props.data.dateOnly
    );

  handleChange = (date) => {
    if (date && !isNaN(date.getTime())) {
      this.setState({
        calendar_answer: date,
        convertedDateTime: this.convertDateTime(date),
      });
      let text = { calendar_answer: date.getTime() };

      if (this.props.data.outputFormat == '')
        this.props.getDataFromComponent(
          text,
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data
        );
      else
        this.props.getDataFromComponent(
          text,
          this.props.data.key,
          this.props.data.question_text,
          this.props.data.data,
          this.props.data.outputFormat,
          this.props.data.timezone
        );
    }
  };

  parseFormat = (outputFormat) => {
    switch (outputFormat) {
      case 'dd LLLL YYYY':
        return 'dd LLLL yyyy';
      case 'dd LLLL YYYY kk:mm':
        return 'dd LLLL yyyy HH:mm';
      case 'dd/MM/YY':
        return 'dd/MM/yy';
      case 'dd/MM/YY kk:mm':
        return 'dd/MM/yy HH:mm';
      case 'dd/MM/YYYY':
        return 'dd/MM/yyyy';
      case 'dd/MM/YYYY kk:mm':
        return 'dd/MM/yyyy HH:mm';
      case 'dd-MM-YYYY':
        return 'dd-MM-yyyy';
      case 'dd-MM-YYYY kk:mm':
        return 'dd-MM-yyyy HH:mm';
      case 'MM/dd/YYYY':
        return 'MM/dd/yyyy';
      case 'MM/dd/YYYY kk:mm':
        return 'MM/dd/yyyy HH:mm';
      case 'YYYY-MM-dd':
        return 'yyyy-MM-dd';
      case 'YYYY-MM-dd kk:mm':
        return 'yyyy-MM-dd HH:mm';
      case 'Unix':
        return 'utc';
      default:
        return 'dd LLLL yyyy HH:mm';
    }
  };

  render() {
    const { data } = this.props;
    const { outputFormat, dateOnly } = data;
    let format = this.parseFormat(outputFormat);
    if (dateOnly && format.includes('HH:mm')) {
      format = format.replace(' HH:mm', '');
    }
    const showTimePicker = !dateOnly && format.includes('m');
    return (
      <Grid container>
        <Grid item xs={12}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            {showTimePicker ? (
              <DateTimePicker
                variant={'inline'}
                ampm={false}
                autoOk={true}
                disabled={data.read_only}
                value={
                  this.isValidDate(this.state.calendar_answer)
                    ? this.state.calendar_answer
                    : null
                }
                format={format}
                onChange={this.handleChange}
              />
            ) : (
              <DatePicker
                variant={'inline'}
                disabled={data.read_only}
                autoOk={true}
                format={format}
                value={
                  this.isValidDate(this.state.calendar_answer)
                    ? this.state.calendar_answer
                    : null
                }
                onChange={this.handleChange}
              />
            )}
          </LocalizationProvider>
        </Grid>
        {this.state.convertedDateTime && (
          <Grid item xs={12}>
            <div
              style={{
                color: 'rgba(134, 134, 133, 0.87)',
                fontSize: '12px',
                marginTop: '10px',
              }}
            >
              {this.state.convertedDateTime.formatted} in{' '}
              {this.state.convertedDateTime.label}
            </div>
          </Grid>
        )}
      </Grid>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    form: state.form,
  };
};

Calendar.propTypes = {
  data: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(Calendar);
